import { createComponentStore } from '../../utils/createComponentStore';

const generateDefaultKey = () =>
  'converged_output_' + Math.floor(Math.random() * 90000 + 10000).toString();

const initData = () => ({
  outputKey: generateDefaultKey(),
});

const { getStore, defaultStore } = createComponentStore({
  type: 'converge_threads',
  endpoint: 'converge_threads',
  registryKey: 'converge_threads',
  initData,

  onLoadData: (rawData) => {
    const d = { ...initData(), ...rawData };
    if (rawData.outputPlaceholderKey) {
      d.outputKey = rawData.outputPlaceholderKey;
    }
    delete d.outputPlaceholderKey;
    if (!d.outputKey) d.outputKey = generateDefaultKey();
    return d;
  },

  extraActions: (set) => ({
    setOutputPlaceholderKey: (value) =>
      set((s) => ({ data: { ...s.data, outputKey: value } })),
  }),
});

export const getConvergeThreadsStore = getStore;
export default defaultStore;
